import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { axiosClient } from "../axiosClient";
import { MailType } from "../../models/Mail";
import { Address, LeadAddress } from "../../models/Address";

export const fetchMailClients = createAsyncThunk("mail/fetchMailClients", async () => {
    const response: AxiosResponse<any[]> = await (await axiosClient()).get(`/mail`);
    return response.data
});

export const checkMailClientAddress = createAsyncThunk("mail/checkMailClientAddress", async (params:{clientId: number}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<Address> = await (await axiosClient()).get(`/mail/clients-check/${params.clientId}`);
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const createMailClient = createAsyncThunk("mail/createMailClient", async (params:{newMailClient: any}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<any> = await (await axiosClient()).post(`/mail/clients`, {...params.newMailClient});
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const checkMailLeadAddress = createAsyncThunk("mail/checkMailLeadAddress", async (params:{leadId: number}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<LeadAddress> = await (await axiosClient()).get(`/mail/leads-check/${params.leadId}`);
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const createMailLead = createAsyncThunk("mail/createMailLead", async (params:{newMailLead: any}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<any> = await (await axiosClient()).post(`/mail/leads`, {...params.newMailLead});
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const fetchAgencyMailTypes = createAsyncThunk("mail/fetchAgencyMailTypes", async (agencyId: number) => {
    const response: AxiosResponse<MailType[]> = await (await axiosClient()).get(`/agencies/${agencyId}/mail-types`);
    return response.data
});

export const createAgencyMailType = createAsyncThunk("mail/createAgencyMailType", async (params:{agencyId: number, newMailType: MailType}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<MailType> = await (await axiosClient()).post(`/agencies/${params.agencyId}/mail-types`, {...params.newMailType});
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const updateAgencyMailType = createAsyncThunk("mail/updateAgencyMailType", async (params:{agencyId: number, typeId: number, updateMailType: MailType}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<MailType> = await (await axiosClient()).patch(`/agencies/${params.agencyId}/mail-types/${params.typeId}`, {...params.updateMailType});
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const deleteAgencyMailType = createAsyncThunk("mail/deleteAgencyMailType", async (params:{agencyId: number, typeId: number}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<MailType[]> = await (await axiosClient()).delete(`/agencies/${params.agencyId}/mail-types/${params.typeId}`);
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});